import { ILegScanProps } from "../../../../../../../@types/components/legScanDetailsprops.types";
import MeasurementTable from "./MeasurementTable";

const withType = (value?: string, type?: string) => {
	if (!value) return value;
	return type ? `${value} (${type})` : value;
};

const ScanAngles = ({ legScan }: ILegScanProps) => {
	const angleRows = [
		{ label: "Heel Angle (deg)", left: legScan.left_heel_angle, right: legScan.right_heel_angle },
		{ label: "Leg Angle (deg)", left: legScan.left_leg_angle, right: legScan.right_leg_angle },
		{
			label: "Hallux Angle (deg)",
			left: withType(legScan.left_hallux_angle, legScan.left_hallux_angle_type),
			right: withType(legScan.right_hallux_angle, legScan.right_hallux_angle_type)
		},
		{ label: "Toe 1 Angle (deg)", left: legScan.left_toe1_angle, right: legScan.right_toe1_angle }
	];

	return (
		<div className="measurement-tables-row">
			<MeasurementTable title="More" rows={angleRows} />
		</div>
	);
};

export default ScanAngles;
